import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { convertTo12HourFormat } from "../Utils/common";

const SlotSelector = ({
  startDateTime, // ISO string with date and time
  duration = 60,
  handlerequest,
  availableSlots,
  selectedSlots,
  setSelectedSlots,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const generateSlots = () => {
    const slots = [];
    const baseStart = dayjs(startDateTime);
    const baseEnd = baseStart.add(duration, "minute");
    const step = 30;
    const now = dayjs();
    const isToday = baseStart.isSame(now, "day");

    for (let offset = -120; offset <= 120; offset += step) {
      if (offset === 0) continue;
      const slotStart = baseStart.add(offset, "minute");
      const slotEnd = slotStart.add(duration, "minute");

      if (isToday && slotStart.isBefore(now)) continue;

      slots.push({
        label: `${slotStart.format("DD MMM, hh:mm A")} - ${slotEnd.format(
          "DD MMM, hh:mm A"
        )}`,
        value: `${slotStart.toISOString()}to${slotEnd.toISOString()}`,
      });
    }

    return slots;
  };

  const [slots, setSlots] = useState();
  useEffect(() => {
    if (availableSlots && availableSlots?.length > 0) {
      setSlots(availableSlots);
    } else {
      const slots = generateSlots();
      setSlots(slots);
    }
  }, [startDateTime]);

  const handleChange = (value) => {
    setSelectedSlots((prev) =>
      prev.includes(value) ? prev.filter((s) => s !== value) : [...prev, value]
    );
  };

  return (
    <>
      <div className="row mx-0 mt-3">
        <div className="col-12 text-danger px-0">
          *Please confirm only available slots to prevent double-booking issues
          for your venue!
        </div>
      </div>
      <div className="row mx-0 mt-3">
        {slots?.map((slot, index) => (
          <div key={index} className="form-check col-6 mb-2 fs-14 fw-500">
            <input
              type="checkbox"
              className="form-check-input"
              id={`slot-${index}`}
              checked={selectedSlots.includes(slot.value)}
              onChange={() => handleChange(slot.value)}
            />
            <label className="form-check-label" htmlFor={`slot-${index}`}>
              {slot.label}
            </label>
          </div>
        ))}
      </div>
      {/* <div className="row mx-0 mt-3">
        <div className="col-12 text-center">
          <button
            className="staff-button px-3"
            onClick={() => {
              if (!isLoading) {
                setIsLoading(true);
                handlerequest(false, selectedSlots);
              }
            }}
          >
            Notify User
          </button>
          {isLoading && (
            <img className="img-fluid ms-2" src="/images/loder.svg" />
          )}
        </div>
      </div> */}
    </>
  );
};

export default SlotSelector;
